import React from "react";
import "./ComentariosSkeleton.css";

const ComentarioSkeletonItem = ({ resposta = false }) => (
  <div className={`skeleton-comentario ${resposta ? "skeleton-resposta" : ""}`}>
    <div className="skeleton-avatar" />

    <div className="skeleton-comentario-corpo">
      <div className="skeleton-header">
        <div className="skeleton-nome" />
        <div className="skeleton-data" />
      </div>

      <div className="skeleton-linha skeleton-linha-1" />
      <div className="skeleton-linha skeleton-linha-2" />
      <div className="skeleton-linha skeleton-linha-3" />

      <div className="skeleton-acoes">
        <div className="skeleton-acao" />
        <div className="skeleton-acao" />
        <div className="skeleton-acao-pequena" />
      </div>
    </div>
  </div>
);

const ComentariosSkeleton = () => {
  return (
    <div className="comentarios-section skeleton-comentarios">
      {/* Comentários */}
      <div className="skeleton-comentarios-lista">
        <ComentarioSkeletonItem />

        <ComentarioSkeletonItem />

        <ComentarioSkeletonItem />

        <ComentarioSkeletonItem resposta />

        <ComentarioSkeletonItem />
      </div>
    </div>
  );
};

export default ComentariosSkeleton;